import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import ABanner from './components/Banner';
import CSection3 from './components/Section3';
import DSection4 from './components/Section4';
import EOther from './components/EOther';
import ScrollMagicFn from '@/utils/ScrollMagic';

export default function XboostH5() {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`${css.xboost_h5} xboost_h5`}>
            <ABanner />
            <CSection3 />
            <DSection4 />
            <EOther />
        </div>
    );
}
